import { Card, Flex, Typography } from "antd";

import { observer } from "mobx-react-lite";
import { getStatusMessage, NormalizedError } from "services";
import { ReactComponent as ErrorIcon } from "images/error-icon.svg";
import styles from "./errorCard.module.css";
import { parseErrorMessage } from "utils";
import { CustomButton } from "ui/Buttons";

type ErrorCardProps = {
  status: number | null;
  description: NormalizedError | undefined;
  iconSize?: number;
  fn?: () => void | Promise<void>;
  buttonText?: string;
  redColor?: boolean;
};
export const ErrorCard = observer(
  ({ status, description, iconSize = 224, fn, buttonText = "Попробовать снова", redColor = false }: ErrorCardProps) => {
    return (
      <Flex justify="center" className={`${redColor ? styles.redColor : ""}`}>
        <Flex vertical gap="large" align="center">
          <Flex vertical align="center">
            <ErrorIcon style={{ width: iconSize }} />
            <Flex vertical gap="small" align="center" style={{ maxWidth: "350" }}>
              <Typography.Title level={3} className={`margin-none ${redColor ? styles.redTitle : ""}`}>
                {getStatusMessage(status)}
              </Typography.Title>
              <Typography.Text className={`text-center ${redColor ? styles.redText : "text-description"}`}>
                {description ? parseErrorMessage(description) : "Ошибка запроса данных"}
              </Typography.Text>
            </Flex>
          </Flex>
          <CustomButton variant="dashed" onClick={fn}>
            {buttonText}
          </CustomButton>
        </Flex>
      </Flex>
    );
  }
);
